import { Box, SxProps, Theme, Typography } from '@mui/material'
import { LogoNunaKey } from 'assets'
import { useDataLanding } from 'hooks'
import { sliderBrandTitle, sliderLogo, sliderLogoContainer } from 'styles'

type Props = {
  sxTextProps?: SxProps<Theme>
  sxImgProps?: SxProps<Theme>
  title?: string
}

export const NunaLabel = ({ sxTextProps, sxImgProps, title }: Props) => {
  const { content } = useDataLanding()
  return (
    <Box sx={{ ...sliderLogoContainer }}>
      <Box
        component="img"
        src={LogoNunaKey}
        alt="Nuna Icon"
        sx={{ ...sliderLogo, ...sxImgProps }}
      />
      <Typography variant="h3" sx={{ ...sliderBrandTitle, ...sxTextProps }}>
        {title ?? content?.slider?.brandName}
      </Typography>
    </Box>
  )
}
